import { render, staticRenderFns } from "./pianifica.vue?vue&type=template&id=bbd94658&scoped=true&"
import script from "./pianifica.vue?vue&type=script&lang=js&"
export * from "./pianifica.vue?vue&type=script&lang=js&"
import style0 from "./pianifica.vue?vue&type=style&index=0&id=bbd94658&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd94658",
  null
  
)

export default component.exports